import { create } from 'zustand';

import { User } from '@/types';

type Store = {
    user: User | null;
    setUser: (user: User | null) => void;
};

export const useUserStore = create<Store>((set) => ({
    user: null,
    setUser: (user: User | null) => set({ user }),
}));
